import React, { FunctionComponent, useMemo } from 'react';
import { compose } from 'recompose';
import { ApiDataBinding, withApiData } from 'react-api-data';
import { ApiResponse, CrossIxConnection } from 'constants/api';
import Select from 'react-select';
import { get } from 'lodash';
import { NONE_SELECTED } from 'constants/index';
import { NetworkRequestStatus } from 'constants/literals';

interface InProps {
    onChange: (cross_ix_connection_uuid: string | null) => void;
    value: string | undefined;
}

interface EnhanceProps {
    crossIxConnectionsRequest: ApiDataBinding<ApiResponse<{ cross_ix_connections: CrossIxConnection[] }>>;
}

type Props = InProps & EnhanceProps;

type OptionType = {
    label: string;
    value: string | null;
}

const NoneOption = { label: NONE_SELECTED, value: null };

const enhance = compose<Props, InProps>(
    withApiData(
        {
            crossIxConnectionsRequest: 'getCrmCrossIxConnections'
        }
    )
);

const CrossIxConnectionSelect: FunctionComponent<Props> = ({ crossIxConnectionsRequest, value, onChange }) => {
    const options = useMemo(
        (): OptionType[] => {
            const responseOptions: OptionType[] = get(crossIxConnectionsRequest, 'data.data.cross_ix_connections', []).map((crossIxConnection: CrossIxConnection) => {
                return {
                    label: crossIxConnection.xml_id,
                    value: crossIxConnection.uuid
                };
            });
            responseOptions.unshift(NoneOption);

            return responseOptions;
        },
        [crossIxConnectionsRequest]
    );

    const selectedOption = options.find(option => option.value === value);

    if (crossIxConnectionsRequest.request.networkStatus === NetworkRequestStatus.Loading) {
        return (
            <Select isLoading={true} isDisabled={true} />
        );
    }

    const filterOption = (option: OptionType, inputValue: string): boolean => {
        return (option.label.match(inputValue) || []).length > 0;
    };

    const handleOnChange = (option: OptionType) => {
        onChange(option.value);
    };

    return (
        <Select
            options={options}
            value={selectedOption}
            onChange={handleOnChange}
            filterOption={filterOption}
            isLoading={false}
            isDisabled={false}
        />
    );
};

export default enhance(CrossIxConnectionSelect);
